import React from 'react';

import type { CourseCardProps } from '../../types';

const Wrapper: React.FC<Partial<CourseCardProps>> = props => {
  const mountRef = React.useRef(false);
  const { children, ...rest } = props;

  const previewWrapper = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    mountRef.current = true;
    return () => {
      mountRef.current = false;
    };
  }, []);

  const handleKeyUp = (event: KeyboardEvent) => {
    if (event.keyCode === 27) {
      event.stopPropagation();
    }
  };

  React.useEffect(() => {
    document.addEventListener('keyup', handleKeyUp);
    return () => document.removeEventListener('keyup', handleKeyUp);
  }, []);

  return (
    <div
      ref={previewWrapper}
      className="CourseCardComponent relative w-full rounded-tl-5 rounded-tr-5 overflow-hidden hover:shadow-4-dp transition-all duration-300 ease-in-out mb-24 sm:mb-0"
      data-testid="course-card-wrapper"
      // this id is used as a item "reference" in some SEO components
      id={`course-item-${rest.originalId}`}
    >
      {React.Children.toArray(children).map(child =>
        React.cloneElement(child as React.ReactElement<any>, rest),
      )}
    </div>
  );
};

export default Wrapper;
